//js to run on scroll to determine animations later
window.onscroll = function(){
  //set vars for scrolling functions
  let max_grip = document.querySelector("div.flex-grid__item.flex-grid__item--50.flex-grid__item--16436555038b2a0a7f-0.type-advanced img.image-fit");
  var max_grip_loc = max_grip.getBoundingClientRect().top;
  
  let high_grip = document.querySelector(".flex-grid__item.flex-grid__item--50.flex-grid__item--3d1d3bcb-81e7-49b6-8507-5e79acf8e927.type-advanced img.image-fit");
  var high_grip_loc = high_grip.getBoundingClientRect().top;
  
  let clip_grip = document.querySelector(".flex-grid__item.flex-grid__item--50.flex-grid__item--8174065a-6712-4664-9ecb-618bf254e1f3.type-advanced img.image-fit");
  var clip_grip_loc = clip_grip.getBoundingClientRect().top;
  
  let fully_gusseted = document.querySelector(".flex-grid__item.flex-grid__item--50.flex-grid__item--16436541078b40fc17-1.type-advanced img.image-fit");
  var fully_gusseted_loc = fully_gusseted.getBoundingClientRect().top;
  
  let lace_truck = document.querySelector(".flex-grid__item.flex-grid__item--50.flex-grid__item--2db6904b-1d55-43b2-b4b2-e340e18bafa5.type-advanced img.image-fit");
  var lace_truck_loc = lace_truck.getBoundingClientRect().top;
  
  let eva_midsole = document.querySelector(".flex-grid__item.flex-grid__item--50.flex-grid__item--65432d22-5cc4-43f2-af71-592271cee04a.type-advanced img.image-fit");
  var eva_midsole_loc = eva_midsole.getBoundingClientRect().top;
  
  let toe_and_heal = document.querySelector(".flex-grid__item.flex-grid__item--50.flex-grid__item--801babcc-91e5-4680-9b27-962eb1be0d29.type-advanced img.image-fit");
  var toe_and_heal_loc = toe_and_heal.getBoundingClientRect().top;

  let body = document.querySelector("body");
  var user_loc = body.getBoundingClientRect().top;
  var body_height = body.getBoundingClientRect().height; 
  var window_height = window.innerHeight; 
  //console.log("mg: "+max_grip_loc);
  //console.log("user: "+user_loc);
  
  //set percentage scrolled for parts of the site
  //max-grip
  var percentage_scrolled_max_grip = (window_height - max_grip_loc) / window_height;
  let left_bound_max_grip = 460;
  var transform_left_bound_x = 460 - (460 * percentage_scrolled_max_grip * 1.8);
  if(transform_left_bound_x < 0){
    transform_left_bound_x = 0;
  }
  max_grip.style.transform = "translatex(-"+transform_left_bound_x+"px)";
  
  //high-grip
  var percentage_scrolled_high_grip = (window_height - high_grip_loc) / window_height;
  let left_bound_high_grip = 460;
  var transform_left_bound_x_high_grip = 460 - (460 * percentage_scrolled_high_grip * 1.8);
  if(transform_left_bound_x_high_grip < 0){
    transform_left_bound_x_high_grip = 0;
  }
  high_grip.style.transform = "translatex(-"+transform_left_bound_x_high_grip+"px)";
  
  //clip_grip
  var percentage_scrolled_clip_grip = (window_height - clip_grip_loc) / window_height;
  let left_bound_clip_grip = 460;
  var transform_left_bound_x_clip_grip = 460 - (460 * percentage_scrolled_clip_grip * 1.8);
  if(transform_left_bound_x_clip_grip < 0){
    transform_left_bound_x_clip_grip = 0;
  }
  clip_grip.style.transform = "translatex(-"+transform_left_bound_x_clip_grip+"px)";
  
  //fully gusseted
  var percentage_scrolled_fully_gusseted = (window_height - fully_gusseted_loc) / window_height;
  let left_bound_fully_gusseted = 460;
  var transform_left_bound_x_fully_gusseted = 460 - (460 * percentage_scrolled_fully_gusseted * 1.8);
  if(transform_left_bound_x_fully_gusseted < 0){
    transform_left_bound_x_fully_gusseted = 0;
  }
  fully_gusseted.style.transform = "translatex("+transform_left_bound_x_fully_gusseted+"px)";
  
  //lace truck
  var percentage_scrolled_lace_truck = (window_height - lace_truck_loc) / window_height;
  let left_bound_lace_truck = 460;
  var transform_left_bound_x_lace_truck = 460 - (460 * percentage_scrolled_lace_truck * 1.8);
  if(transform_left_bound_x_lace_truck < 0){
    transform_left_bound_x_lace_truck = 0;
  }
  lace_truck.style.transform = "translatex("+transform_left_bound_x_lace_truck+"px)";
  
  //eva midsole
  var percentage_scrolled_eva_midsole = (window_height - eva_midsole_loc) / window_height;
  let left_bound_eva_midsole = 460;
  var transform_left_bound_x_eva_midsole = 460 - (460 * percentage_scrolled_eva_midsole * 1.8);
  if(transform_left_bound_x_eva_midsole < 0){
    transform_left_bound_x_eva_midsole = 0;
  }
  eva_midsole.style.transform = "translatex("+transform_left_bound_x_eva_midsole+"px)";
  
  //toe and heal
  var percentage_scrolled_toe_and_heal = (window_height - toe_and_heal_loc) / window_height;
  let left_bound_toe_and_heal = 460;
  var transform_left_bound_x_toe_and_heal = 460 - (460 * percentage_scrolled_toe_and_heal * 1.8);
  if(transform_left_bound_x_toe_and_heal < 0){
    transform_left_bound_x_toe_and_heal = 0;
  }
  toe_and_heal.style.transform = "translatex("+transform_left_bound_x_toe_and_heal+"px)";
}

//onload function for width of tech page
//classes: .flex-grid__item.flex-grid__item--50.flex-grid__item--16436541078b40fc17-0.type-advanced, .flex-grid__item.flex-grid__item--100.flex-grid__item--e4285dd1-a61f-4751-802c-ae1037b8bc3c.type-advanced, .flex-grid__item.flex-grid__item--50.flex-grid__item--f45dafb6-85a6-4387-b3d6-02a6271b0b7a.type-advanced, .flex-grid__item.flex-grid__item--50.flex-grid__item--05351af8-6bb3-4c63-ac2e-d112ad029b7c.type-advanced, .flex-grid__item.flex-grid__item--50.flex-grid__item--a660cf09-e79f-4d83-b9df-2a3cccdb3428.type-advanced


function add_padding_to_construction(){
  var const_header = document.querySelector('.flex-grid__item.flex-grid__item--100.flex-grid__item--e4285dd1-a61f-4751-802c-ae1037b8bc3c.type-advanced');
  var align_to = document.querySelector('#shopify-section-template--14346798268489__1643648752c84b44f5 .text-left.page-width');
  var padding_left = Math.floor(align_to.getBoundingClientRect().left);
  console.log(align_to.getBoundingClientRect().left);
  console.log(const_header);
  let grid_item_1 = document.querySelector('.flex-grid__item.flex-grid__item--50.flex-grid__item--16436541078b40fc17-0.type-advanced')
  let grid_item_2 = document.querySelector('.flex-grid__item.flex-grid__item--100.flex-grid__item--e4285dd1-a61f-4751-802c-ae1037b8bc3c.type-advanced')
  let grid_item_3 = document.querySelector('.flex-grid__item.flex-grid__item--50.flex-grid__item--f45dafb6-85a6-4387-b3d6-02a6271b0b7a.type-advanced')
  let grid_item_4 = document.querySelector('.flex-grid__item.flex-grid__item--50.flex-grid__item--05351af8-6bb3-4c63-ac2e-d112ad029b7c.type-advanced')
  let grid_item_5 = document.querySelector('.flex-grid__item.flex-grid__item--50.flex-grid__item--a660cf09-e79f-4d83-b9df-2a3cccdb3428.type-advanced')
  
  grid_item_1.style.paddingLeft = padding_left+"px";
  grid_item_2.style.paddingLeft = padding_left+"px";
  grid_item_3.style.paddingLeft = padding_left+"px";
  grid_item_4.style.paddingLeft = padding_left+"px";
  grid_item_5.style.paddingLeft = padding_left+"px";
  
}

window.onload = add_padding_to_construction();
















